// extracted by mini-css-extract-plugin
module.exports = {"container":"HomePageHowWork_container__uknKm","iconsWrapper":"HomePageHowWork_iconsWrapper__1o6l3","textHeader":"HomePageHowWork_textHeader__3NDUl"};